export const tokens = {
  color: {
    primary: "#166534",
    primaryLight: "#EEF4EF",
    primaryMid: "#F0FDF4",
    primaryDark: "#14532D",
    accent: "#16A34A",
    accentLight: "#DCFCE7",
    white: "#FFFFFF",
    black: "#000000",
    neutral50: "#F8FAF8",
    neutral100: "#F3F4F6",
    neutral200: "#E5E7EB",
    neutral300: "#D1D5DB",
    neutral400: "#9CA3AF",
    neutral500: "#6B7280",
    neutral600: "#4B5563",
    neutral700: "#374151",
    neutral800: "#1F2937",
    neutral900: "#0F172A",
    slate100: "#F1F5F9",
    slate200: "#E2E8F0",
    slate700: "#334155",
    amber400: "#FBBF24",
    amber500: "#F59E0B",
    yellow100: "#FEF9C3",
    yellow600: "#CA8A04",
    purple50: "#FAF5FF",
    purple600: "#9333EA",
    blue50: "#EFF6FF",
    blue600: "#2563EB",
    orange50: "#FFF7ED",
    orange600: "#EA580C",
    red50: "#FFF1F2",
    red600: "#E11D48",
    overlay: "rgba(0,0,0,0.04)",
    overlayDark: "rgba(0,0,0,0.45)",
    shadowSm: "rgba(0,0,0,0.04)",
    shadowMd: "rgba(0,0,0,0.08)",
    shadowLg: "rgba(0,0,0,0.12)",
  },

  spacing: {
    0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 8: 8, 10: 10,
    12: 12, 14: 14, 16: 16, 18: 18, 20: 20, 24: 24, 28: 28,
    32: 32, 36: 36, 40: 40, 44: 44, 48: 48, 56: 56, 60: 60,
    64: 64, 72: 72, 80: 80, 96: 96, 120: 120, 160: 160,
  },

  font: {
    size: {
      xs: 11, sm: 12, base: 13, md: 14, lg: 16, xl: 18,
      "2xl": 20, "3xl": 22, "4xl": 24, "5xl": 28, "6xl": 32,
      "7xl": 36, "8xl": 40, "9xl": 48, "10xl": 56, "11xl": 64,
    },
    weight: { normal: 400, medium: 500, semibold: 600, bold: 700, extrabold: 800 },
    family: {
      sans: "'Inter', system-ui, sans-serif",
      serif: "'Playfair Display', serif",
    },
  },

  radius: { sm: 6, md: 8, lg: 12, xl: 16, "2xl": 20, "3xl": 24, full: 9999 },

  motion: {
    fast: "80ms", base: "140ms", slow: "160ms", medium: "200ms",
    ease: "cubic-bezier(0.4,0,0.2,1)", spring: "cubic-bezier(0.34,1.56,0.64,1)",
  },

  breakpoints: { mobile: 767, tablet: 1023 },

  responsive: {
    mobile: {
      pagePaddingX: 16, pagePaddingY: 32, sectionGap: 48, cardGap: 16,
      titleSize: "6xl", subtitleSize: "3xl", bodySize: "base",
    },
    tablet: {
      pagePaddingX: 24, pagePaddingY: 48, sectionGap: 64, cardGap: 20,
      titleSize: "7xl", subtitleSize: "4xl", bodySize: "md",
    },
    desktop: { pagePaddingX: 32, pagePaddingY: 64, sectionGap: 96, cardGap: 24 },
  },
};